import { Breakpoints } from '@/hooks/useBreakpoint';
import styled, { css } from 'styled-components';

export const ContainerPrincipalFluxoAutenticacao = styled.div<{
  $breakpoint: Breakpoints;
}>`
  position: relative;
  overflow: hidden;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: 550px;
  height: 100%;

  ${({ theme }) => {
    return css`
      background-color: ${theme.colors.accent.accent[4]};
      gap: ${theme.spacing[5]}px;
    `;
  }};

  ${({ $breakpoint, theme }) => {
    if ($breakpoint === 'desktop')
      return css`
        padding: ${theme.spacing[6]}px;
      `;
    return css`
      width: 100%;
      padding: ${theme.spacing[5]}px;
    `;
  }};
`;
